var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.rdList.length > 0 ? _c('div', {
    staticClass: "jiemeitao-list"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": _vm.rdList[0].img,
      "alt": ""
    },
    on: {
      "click": function click($event) {
        return _vm.gotoLink(_vm.rdList[0].url);
      }
    }
  })]), _vm._v(" "), _vm._l(_vm.rdList, function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: index > 0,
        expression: "index>0"
      }],
      key: index,
      staticClass: "list"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      },
      on: {
        "click": function click($event) {
          return _vm.gotoLink(item.url);
        }
      }
    })]);
  })], 2) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };